











import { Vue, Component } from 'vue-property-decorator';
import LoaderCircular, { EnumSizes } from '@/components/LoaderCircular.vue';

@Component({
  components: {
    LoaderCircular,
  },
  data: () => ({
    EnumSizes,
  }),
})
export default class BankIdSigned extends Vue {}
